export default {
  authCode: {
    one: '',
    two: '',
    three: '',
    four: '',
  },
}
